// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"187":"b794a95d1f2be1cad3d1","245":"e894a018864213fec2d5","428":"d421d79b32f72b79f536","975":"d94e43f8eb409441d35c","989":"56f0100747dc7e8ed08e"}[chunkId] + ".min.js";
};